import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';

import { Box } from '@mui/material';

import useStores from 'hooks/use-stores';
import CreateButton from 'main/components/APIKeys/components/CreateButton';
import KeysList from 'main/components/APIKeys/components/KeysList';
import LoginButton from 'main/components/APIKeys/components/LoginButton';
import Spinner from 'main/components/APIKeys/components/Spinner';

const APIKeys = ({ scope, selected, onSelect, onLogin, onCreate, renderKeysList }) => {
    const { userStore } = useStores();
    const isAuthorized = userStore.user.isAuthorized;
    const apiKeysLoaded = userStore.apiKeysLoaded;

    useEffect(() => {
        if (isAuthorized && !apiKeysLoaded) {
            userStore.loadApiKeys();
        }
    }, [apiKeysLoaded, isAuthorized, userStore]);

    const filteredApiKeys = useMemo(() => userStore.apiKeys.filter((it) => it.scope.includes(scope)), [
        scope,
        userStore.apiKeys
    ]);

    useEffect(() => {
        if (!selected?.id && filteredApiKeys.length === 1) {
            onSelect?.(filteredApiKeys[0]);
        }
    }, [filteredApiKeys, onSelect, selected]);

    const view = useMemo(() => {
        switch (true) {
            case isAuthorized && !apiKeysLoaded:
                return <Spinner />;
            case isAuthorized && apiKeysLoaded && filteredApiKeys.length > 0:
                return renderKeysList ? (
                    renderKeysList({ apiKeys: filteredApiKeys, selected, onSelect })
                ) : (
                    <KeysList apiKeys={filteredApiKeys} selected={selected} onSelect={onSelect} />
                );
            case isAuthorized && apiKeysLoaded && filteredApiKeys.length === 0:
                return <CreateButton scope={scope} onCreate={onCreate} />;
            case !isAuthorized:
                return <LoginButton onLogin={onLogin} />;
            default:
                return <Spinner />;
        }
    }, [apiKeysLoaded, filteredApiKeys, isAuthorized, onCreate, onLogin, onSelect, renderKeysList, scope, selected]);

    return <Box>{view}</Box>;
};

APIKeys.propTypes = {
    onLogin: PropTypes.func,
    scope: PropTypes.string,
    selected: PropTypes.object,
    onSelect: PropTypes.func,
    onCreate: PropTypes.func,
    renderKeysList: PropTypes.func
};

export default observer(APIKeys);
